<div class="container-fluid tp-box vd-host" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap vd-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">groups</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ title }}</span>
				</div>
				<div class="vd-toolbar">
					<button class="btn btn-success btn-sm" (click)="exportXls()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i>
					</button>
					<button class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i>
					</button>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<div class="table" #print_table>
					<table class="table">
						<thead>
							<tr>
								<th>Vendor ID</th>
								<th>Name</th>
								<th>Address</th>
								<th>Phone</th>
								<th>Terms Code</th>
								<th>Terms Name</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let v of viewing">
								<td>{{ v.supplierid }}</td>
								<td>{{ v.suppname }}</td>
								<td>{{ v.address1 }}</td>
								<td>{{ v.telephone }}</td>
								<td>{{ v.termscode || v.paymentterms || '' }}</td>
								<td>{{ v.termsname || '' }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				[title]="title"
				icon="groups"
				accent="success"
				[value]="data ? total : null"
				[loading]="!data"
				[showView]="!!data"
				(view)="toggleFlip(data, title)">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
